import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import styles from '../Lucky7/styles.module.css'
import FooterLinks from '../FooterLinks';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from "@mui/material";
import GameScreen from './GameScreen';
import FlipClock from "../../FlipClock/FlipClock"
import Lucky7ResultsPopup from './Lucky7ResultsPopup';
import useCasinoBetplace from '../../../api/useCasinoBetplace';
import useRoundLoader from '../../../api/useRoundLoader';
import RoundLoader from '../../Loader/RoundLoader';

const HeartSVG = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M14.7305 1.44C13.0378 -0.48 10.3174 -0.48 8.62468 1.44L8 2.14857L7.37531 1.44C5.68262 -0.48 2.96222 -0.48 1.26952 1.44C-0.423174 3.36 -0.423174 6.44571 1.26952 8.36571L8 16L14.7305 8.36571C16.4232 6.44571 16.4232 3.33714 14.7305 1.44Z" fill="url(#paint0_linear_7450_30900)" />
        <defs><linearGradient id="paint0_linear_7450_30900" x1="3.10791" y1="-0.661257" x2="14.1232" y2="9.04996" gradientUnits="userSpaceOnUse"><stop stop-color="#FE5B42" /><stop offset="1" stop-color="#BA0000" /></linearGradient></defs>
    </svg>
)
const DiamondSVG = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M16 8L8 16L0 8L8 0L16 8Z" fill="url(#paint0_linear_7450_30899)" />
        <defs><linearGradient id="paint0_linear_7450_30899" x1="3.336" y1="3.99543" x2="11.2419" y2="13.219" gradientUnits="userSpaceOnUse"><stop stop-color="#FE5B42" /><stop offset="1" stop-color="#BA0000" /></linearGradient></defs>
    </svg>
)
const ClubSVG = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M12.0167 5.77483C11.8053 5.77483 11.605 5.79603 11.4159 5.81722C11.7942 5.23444 12.0167 4.5457 12.0167 3.81457C12.0167 1.70596 10.2253 0 8.01113 0C5.79694 0 4.00556 1.70596 4.00556 3.81457C4.00556 4.55629 4.22809 5.23444 4.6064 5.81722C4.40612 5.78543 4.20584 5.77483 4.00556 5.77483C1.79138 5.77483 0 7.48079 0 9.5894C0 11.698 1.79138 13.404 4.00556 13.404C5.363 13.404 6.55355 12.7576 7.27677 11.7828C7.32128 13.5417 6.7427 14.9298 5.61892 16H10.3811C9.26843 14.9298 8.68985 13.5417 8.72323 11.7828C9.44645 12.7576 10.637 13.404 11.9944 13.404C14.2086 13.404 16 11.698 16 9.5894C16 7.48079 14.2198 5.77483 12.0167 5.77483Z" fill="url(#paint0_linear_7450_30904)" />
        <defs><linearGradient id="paint0_linear_7450_30904" x1="2.66737" y1="3.51682" x2="12.8332" y2="14.1928" gradientUnits="userSpaceOnUse"><stop stop-color="#454545" /><stop offset="1" /></linearGradient></defs>
    </svg>
)
const SpadeSVG = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M14.7396 6.4L8.0015 0L1.26339 6.4C-0.421131 8 -0.421131 10.6057 1.26339 12.2057C2.92385 13.7829 5.57097 13.8057 7.25549 12.2971C7.1833 13.8286 6.60575 15.04 5.59503 16H10.3839C9.37318 15.04 8.79563 13.8057 8.72343 12.2971C10.408 13.8057 13.0791 13.7829 14.7155 12.2057C16.4241 10.5829 16.4241 8 14.7396 6.4Z" fill="url(#paint0_linear_7450_30905)" />
        <defs><linearGradient id="paint0_linear_7450_30905" x1="3.10819" y1="4.64503" x2="12.397" y2="14.4222" gradientUnits="userSpaceOnUse"><stop stop-color="#454545" /><stop offset="1" /></linearGradient></defs>
    </svg>
)
const PlayCardHeart = (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
        <path d="M4.87281 0.45C4.34384 -0.15 3.49371 -0.15 2.96475 0.45L2.76953 0.671428L2.57432 0.45C2.04535 -0.15 1.19522 -0.15 0.666257 0.45C0.137289 1.05 0.137289 2.01429 0.666257 2.61429L2.76953 5L4.87281 2.61429C5.40177 2.01429 5.40177 1.04286 4.87281 0.45Z" fill="url(#paint0_linear_7652_10809)" />
        <defs><linearGradient id="paint0_linear_7652_10809" x1="1.24075" y1="-0.206643" x2="4.68303" y2="2.82811" gradientUnits="userSpaceOnUse"><stop stop-color="#FE5B42" /><stop offset="1" stop-color="#BA0000" /></linearGradient></defs>
    </svg>
)
const PlayCardDiamond = (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
        <path d="M5.26953 2.5L2.76953 5L0.269531 2.5L2.76953 0L5.26953 2.5Z" fill="url(#paint0_linear_7652_10806)" />
        <defs><linearGradient id="paint0_linear_7652_10806" x1="1.31203" y1="1.24857" x2="3.78262" y2="4.13092" gradientUnits="userSpaceOnUse"><stop stop-color="#FE5B42" /><stop offset="1" stop-color="#BA0000" /></linearGradient></defs>
    </svg>
)
const PlayCardSpade = (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
        <path d="M5.41472 2L3.30906 0L1.2034 2C0.67699 2.5 0.67699 3.31429 1.2034 3.81429C1.7223 4.30714 2.54952 4.31429 3.07593 3.84286C3.05337 4.32143 2.87289 4.7 2.55704 5H4.05356C3.73771 4.7 3.55723 4.31429 3.53467 3.84286C4.06108 4.31429 4.89582 4.30714 5.4072 3.81429C5.94113 3.30714 5.94113 2.5 5.41472 2Z" fill="url(#paint0_linear_7652_10805)" />
        <defs><linearGradient id="paint0_linear_7652_10805" x1="1.7799" y1="1.45157" x2="4.68266" y2="4.50693" gradientUnits="userSpaceOnUse"><stop stop-color="#454545" /><stop offset="1" /></linearGradient></defs>
    </svg>
)
const PlayCardClub = (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
        <path d="M4.56381 1.80464C4.49775 1.80464 4.43516 1.81126 4.37605 1.81788C4.49427 1.63576 4.56381 1.42053 4.56381 1.19205C4.56381 0.533113 4.004 0 3.31207 0C2.62014 0 2.06033 0.533113 2.06033 1.19205C2.06033 1.42384 2.12987 1.63576 2.24809 1.81788C2.18551 1.80795 2.12292 1.80464 2.06033 1.80464C1.3684 1.80464 0.808594 2.33775 0.808594 2.99669C0.808594 3.65563 1.3684 4.18874 2.06033 4.18874C2.48453 4.18874 2.85658 3.98676 3.08259 3.68212C3.09649 4.23179 2.91569 4.66556 2.5645 5H4.05268C3.70498 4.66556 3.52417 4.23179 3.5346 3.68212C3.76061 3.98676 4.13265 4.18874 4.55686 4.18874C5.24879 4.18874 5.80859 3.65563 5.80859 2.99669C5.80859 2.33775 5.25227 1.80464 4.56381 1.80464Z" fill="url(#paint0_linear_7652_10808)" />
        <defs><linearGradient id="paint0_linear_7652_10808" x1="1.64215" y1="1.09901" x2="4.81897" y2="4.43524" gradientUnits="userSpaceOnUse"><stop stop-color="#454545" /><stop offset="1" /></linearGradient></defs>
    </svg>
)

const LockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
        <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
    </svg>
)

const betOptions = [
    [
        { odds: "2", label: "Low Card", betType: "low" },
        { odds: "", label: "7", betType: "lion", isCard: true },
        { odds: "2", label: "High Card", betType: "high" }
    ],
    [
        { odds: "2.1", label: "Even", betType: "even" },
        { odds: "1.79", label: "Odd", betType: "odd" }
    ],
    [
        { odds: "1.95", label: [DiamondSVG, HeartSVG], betType: "red" },
        { odds: "1.95", label: [ClubSVG, SpadeSVG], betType: "black" }
    ]
];

const cardGroups = [
    [
        { label: 'card_1', odds: "4", cards: ["A", "2", "3"], betType: 'group_a_2_3' },
        { label: 'card_2', odds: "4", cards: ["4", "5", "6"], betType: 'group_4_5_6' },
        { label: 'card_3', odds: "4", cards: ["8", "9", "10"], betType: 'group_8_9_10' },
        { label: 'card_4', odds: "4", cards: ["J", "Q", "K"], betType: 'group_j_q_k' }
    ]
];

const allCards = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
const jqkcards = ["J", "Q", "K"];

function Lucky7({ onBetSelect, locked, socketData, settledData, gameId = 4 ,hookExposureData}) {
    const [betDialogOpen, setBetDialogOpen] = useState(false);
    const [selectedBet, setSelectedBet] = useState(null);
    const [resultsPopupOpen, setResultsPopupOpen] = useState(false);
    const remainingTime = socketData?.remainingTime;

   
    const [exposureData, setExposureData] = useState(null);

    const isLargeScreen = useMediaQuery("(min-width:1024px)");
        const roundId   = socketData?.roundId
;
    const [animTimer, setAnimTimer] = useState(null);

    useEffect(() => {
        if (hookExposureData && hookExposureData.gameId === gameId) {
            setExposureData(hookExposureData);
        }
    }, [hookExposureData, gameId]);
   useEffect(() => {
     if (roundId) {
       setExposureData(null);
     }
   }, [roundId]);

    const getExposureValue = (key) => {
        if (!exposureData) return null;
        const keyMap = {
            'low': 'lowWins', 'high': 'highWins',
            'even': 'even', 'odd': 'odd',
            'red': 'red', 'black': 'black',
            'group_a_2_3': 'groupA23', 'group_4_5_6': 'group456',
            'group_8_9_10': 'group8910', 'group_j_q_k': 'groupJQK',
            'CARD_A': 'cardA', 'CARD_2': 'card2', 'CARD_3': 'card3',
            'CARD_4': 'card4', 'CARD_5': 'card5', 'CARD_6': 'card6',
            'CARD_7': 'card7', 'CARD_8': 'card8', 'CARD_9': 'card9',
            'CARD_10': 'card10', 'CARD_J': 'cardJ', 'CARD_Q': 'cardQ', 'CARD_K': 'cardK',
        };
        const val = exposureData[keyMap[key] ?? key];
        if (val === undefined || val === 0) return null;
        return val;
    };

    const ExposureLabel = ({ value }) => {
        if (value === null || value === undefined) return null;
         const isNegative = value < 0;
        return (
            <Typography sx={{
                fontSize: '11px',
                fontWeight: 600,
               color: isNegative ? '#ff4444' : '#00c853',
                textAlign: 'center',
                lineHeight: 1,
                mt: '2px',
            }}>
                {value}
            </Typography>
        );
    };

    const handleNumberBoxClick = (odds, label, section, card = null) => {
        if (locked) return;
        let betType = '';
        let selection = '';
        let displayLabel = '';

        if (section === 'betOptions') {
            const raw = label.betType;
            if (raw === 'low' || raw === 'high') {
                betType = 'MAIN';
                selection = raw.toUpperCase();
            } else {
                betType = 'SIDE';
                selection = raw.toUpperCase();
            }
            displayLabel = typeof label.label === 'string'
                ? label.label
                : (raw === 'red' ? 'Red Symbols' : 'Black Symbols');
        } else if (section === 'cardGroups') {
            betType = 'SIDE';
            selection = label.betType.toUpperCase();
            const cardNames = Array.isArray(label.cards) ? label.cards.join('-') : '';
            displayLabel = cardNames ? `Group ${cardNames}` : 'Group Bet';
        } else if (section === 'allCards' || section === 'jqk') {
            betType = 'SIDE';
            const cardKey = card === '1' ? 'A' : card.toUpperCase();
            selection = `CARD_${cardKey}`;
            displayLabel = card === '1' ? 'A' : card;
        }

        const betData = {
            label: displayLabel,
            odds: parseFloat(odds),
            betType: betType,
            selection: selection,
        };
        setSelectedBet(betData);
        setBetDialogOpen(true);
        if (onBetSelect) onBetSelect(betData);
    };

    const handleBetScreenClose = () => {
        setBetDialogOpen(false);
        setSelectedBet(null);
    };

    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    // Reusable card render — card bahar wrapper mein, ExposureLabel neeche bahar
    const renderPlayCard = (card, exposureKey, onClick, extraSx = {}) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ...extraSx }}>
            <Box
                className={styles.PlayCard}
                onClick={onClick}
                sx={{
                    position: 'relative',
                    justifyContent: 'center',
                    cursor: locked ? 'not-allowed' : 'pointer',
                }}
            >
                <Typography className={styles.PlayCardText}>{card === '1' ? 'A' : card}</Typography>
                <Box className={styles.SvgBox}>
                    <Box className={styles.InnerSvgBox}>{PlayCardSpade}{PlayCardDiamond}</Box>
                    <Box className={styles.InnerSvgBox}>{PlayCardClub}{PlayCardHeart}</Box>
                </Box>
                {locked && (
                    <Box className={styles.bettinglocked_icon_container}><LockIcon /></Box>
                )}
            </Box>
            <ExposureLabel value={getExposureValue(exposureKey)} />
        </Box>
    );

    return (
    
        <Box className={styles.MatchScreen_container}>
            {/* 1st Box */}
<Box sx={{ position: 'relative', width: '100%' }}>
 <GameScreen
    bettingClosed={socketData?.bettingClosed === true}
    animationTime={typeof socketData?.animationTime === 'number' ? socketData.animationTime : undefined}
    socketData={socketData}
    settledData={socketData?.settlement ?? settledData}
    remainingTime={remainingTime}
    onAnimStart={() => setAnimTimer(0)}
    onAnimEnd={() => setAnimTimer(null)}
/>
    <Box sx={{ position: 'absolute', bottom: '8px',  zIndex: 99, right: '8px' }}>
        <FlipClock
            time={
                animTimer !== null
                    ? animTimer
                    : (socketData?.remainingTime )
            }
        />
    </Box>
</Box>
            <Box className={styles.boxcontainer}>
                {/* betOptions rows */}
                <Box className={styles.Box1}>
                    {betOptions.map((row, rowIndex) => (
                        <Box key={rowIndex} className={styles.InnerBox1}>
                            {row.map((item, colIndex) => (
                                <Box
                                    key={colIndex}
                                    sx={{
                                        minWidth: rowIndex === 0 ? '30%' : '48%',
                                        position: 'relative',
                                        justifyContent: 'center',
                                        '&:hover': { cursor: item.isCard ? 'none' : (locked ? 'not-allowed' : 'pointer') },
                                    }}
                                    onClick={() => {
                                        if (item.isCard) return;
                                        handleNumberBoxClick(item.odds, item, 'betOptions', item.betType);
                                    }}
                                >
                                    <Typography className={styles.NoText}>{item.odds}</Typography>

                                    {item.isCard ? (
                                        <Box className={styles.PlayCard} sx={{ margin: '8px auto 0', pointerEvents: 'none',height: '38px' ,width:'38'}}>
                                            <Typography className={styles.PlayCardText}>{item.label}</Typography>
                                            <Box className={styles.SvgBox}>
                                                <Box className={styles.InnerSvgBox}>{PlayCardSpade}{PlayCardDiamond}</Box>
                                                <Box className={styles.InnerSvgBox}>{PlayCardClub}{PlayCardHeart}</Box>
                                            </Box>
                                            
                                        </Box>
                                    ) : (
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <Box
                                                className={styles.BlueBox}
                                                sx={{
                                                    position: 'relative',
                                                    justifyContent: 'center',
                                                    cursor: locked ? 'not-allowed' : 'pointer',
                                                     pointerEvents: locked ? 'none' : 'auto', 
                                                   width: 'calc(100% - 14px)',
                                                }}
                                            >
                                                {Array.isArray(item.label)
                                                    ? item.label.map((icon, idx) => <Box key={idx}>{icon}</Box>)
                                                    : <Typography className={styles.BlueBoxText}>{item.label}</Typography>
                                                }
                                                {locked && <Box className={styles.bettinglocked_icon_container}><LockIcon /></Box>}
                                            </Box>
                                            <ExposureLabel value={getExposureValue(item.betType)} />
                                        </Box>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    ))}
                </Box>

                {/* cardGroups */}
                {/* <Box className={styles.Box1}>
                    {cardGroups.map((groupRow, rowIndex) => (
                        <Box key={rowIndex} className={styles.InnerBox1}>
                            {groupRow.map((group, colIndex) => (
                                <Box key={colIndex}
                                    sx={{
                                        minWidth: '48%',
                                        position: 'relative',
                                        justifyContent: 'center',
                                        cursor: locked ? 'not-allowed' : 'pointer',
                                    }}
                                    className={styles.InnerBox2}
                                    onClick={() => handleNumberBoxClick(group.odds, group, 'cardGroups', group.betType)}
                                >
                                    <Typography className={styles.NoText}>{group.odds}</Typography>
                                    
                                    <Box className={styles.InnerCradBox}>
                                        {group.cards.map((card, cardIndex) => (
                                            renderPlayCard(
                                                card,
                                                null, // group cards pe individual exposure nahi
                                                (e) => {
                                                    e.stopPropagation();
                                                    handleNumberBoxClick(group.odds, group, 'cardGroups', card, group.betType);
                                                }
                                            )
                                        ))}
                                    </Box>
                                     <ExposureLabel value={getExposureValue(group.betType)} />
                                </Box>
                            ))}
                        </Box>
                    ))}
                </Box> */}

                {/* allCards + jqk */}
                <Box className={styles.LowerBox} sx={{ width: '100%' }}>
                    <Typography className={styles.NoText}>12</Typography>
                    {isLargeScreen ? (
                        <Box className={styles.PlayCardsBox}>
                            {allCards.map((card, index) => (
                                <Box key={index}>
                                    {renderPlayCard(
                                        card,
                                        `CARD_${card === '1' ? 'A' : card.toUpperCase()}`,
                                        () => handleNumberBoxClick("12", card, 'allCards', card)
                                    )}
                                </Box>
                                
                            ))}
                        </Box>
                    ) : (
                        <>
                            <Box className={styles.PlayCardsBox}>
                                {allCards.slice(0, 9).map((card, index) => (
                                    <Box key={index}>
                                        {renderPlayCard(
                                            card,
                                            `CARD_${card === '1' ? 'A' : card.toUpperCase()}`,
                                            () => handleNumberBoxClick("12", card, 'allCards', card)
                                        )}
                                    </Box>
                                ))}
                            </Box>
                          {/* {allCards.length > 9 && (
    <Box className={styles.PlayCardsBox}>
        {allCards.slice(9).map((card, index) => (
            <Box key={index}>
                {renderPlayCard(
                    card,
                    `CARD_${card === '1' ? 'A' : card.toUpperCase()}`,
                    () => handleNumberBoxClick("12", card, 'allCards', card)
                )}
            </Box>
        ))}
    </Box>
)} */}
                        </>
                    )}

                    <Box className={styles.JQKBox}>
                       {[...allCards.slice(9), ...jqkcards].map((card, cardIndex) => (
                            <Box key={cardIndex}>
                                {renderPlayCard(
                                    card,
                                    `CARD_${card.toUpperCase()}`,
                                    () => handleNumberBoxClick("12", card, 'jqk', card)
                                )}
                            </Box>
                        ))}
                    </Box>
                </Box>

                <Lucky7ResultsPopup
                    open={resultsPopupOpen}
                    onClose={() => setResultsPopupOpen(false)}
                    resultData={settledData}
                />
            <FooterLinks
    socketData={socketData}
    gameType="Lucky7"
    settledData={socketData?.settlement ?? settledData}
/>
            </Box>
        </Box>
        
    );
}

export default Lucky7;